import axios from 'axios';
import {
  CREATE_NEW_INTERNAL_USER_URL,
  GET_ALL_ROLES_URL,
  GET_ALL_INTERNAL_USERS,
  GET_ACCESS_LOGS,
  UPDATE_INTERNAL_USER,
  DELETE_INTERNAL_USER,
  RESET_INTERNAL_USER_PASSWORD,
} from 'api/access/constant';
import { createErrorFromAxiosMultipleErrors } from 'api/utilities';
import { ASCENDING } from 'constants/access/internalUsersTableSortMethod';

export function performGetAllRoles() {
  try {
    return axios.get(`${GET_ALL_ROLES_URL}`).then(response => {
      return Promise.resolve(response);
    });
  } catch (error) {
    throw createErrorFromAxiosMultipleErrors(error);
  }
}

export function performCreateNewUser(payload) {
  return axios
    .post(`${CREATE_NEW_INTERNAL_USER_URL}`, payload)
    .then(response => {
      return Promise.resolve(response);
    })
    .catch(error => {
      return Promise.reject(error);
    });
}

export function performGetAllInternalUsers(payload) {
  const { page, size, email, roleId, sort } = payload;
  let reqURI = `${GET_ALL_INTERNAL_USERS}?page=${page}&size=${size}`;
  if (email) reqURI += `&email=${email}`;
  if (roleId) reqURI += `&roleId=${roleId}`;

  if (sort) {
    if (sort.column) reqURI += `&sort=${sort.column}`;
    if (sort.direction === ASCENDING) reqURI += ',ASC';
    else reqURI += ',DESC';
  }

  return axios
    .get(reqURI)
    .then(response => {
      return Promise.resolve(response);
    })
    .catch(error => {
      return Promise.reject(error);
    });
}

export function performGetAccessLogs(payload) {
  const { group, item, page, size } = payload;

  return axios
    .get(
      `${GET_ACCESS_LOGS}?group=${group}&item=${item}&page=${page}&size=${size}&sort=createdAt,desc`
    )
    .then(response => {
      return Promise.resolve(response);
    })
    .catch(error => {
      return Promise.reject(error);
    });
}

export function performUpdateUser(payload) {
  const { userId, reqBody } = payload;
  return axios
    .put(`${UPDATE_INTERNAL_USER}/${userId}`, reqBody)
    .then(response => {
      return Promise.resolve(response);
    })
    .catch(error => {
      return Promise.reject(error);
    });
}

export function performDeleteUser(payload) {
  const { id } = payload;
  return axios
    .delete(`${DELETE_INTERNAL_USER}/${id}`)
    .then(response => {
      return Promise.resolve(response);
    })
    .catch(error => {
      return Promise.reject(error);
    });
}

export function performResetUserPassword(payload) {
  const { id } = payload;
  return axios
    .patch(`${RESET_INTERNAL_USER_PASSWORD}/${id}`)
    .then(response => {
      return Promise.resolve(response);
    })
    .catch(error => {
      return Promise.reject(error);
    });
}
